// Simple loading status helper.
import { computed, ref } from 'vue';

export default function useLoadingStatus() {
  const counter = ref(0);
  const isLoading = computed(() => counter.value > 0);
  const whileLoading = async function (f) {
    if (isLoading.value) {
      return;
    }

    counter.value++;
    try {
      return await f();
    } finally {
      counter.value--;
    }
  };

  return {
    isLoading,
    whileLoading,
  };
}
